import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/core';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui-kit/tabs';
import { KPIS_TABS, KpisTab } from '@/constant/app-paths';
import { useUrlTab } from '@/hooks/use-linked-record';
import { SoonBadge, SoonPanel } from '@/modules/settings';
import { KpiConfigurationForm } from '../../components/kpi-configuration-form/kpi-configuration-form';

/**
 * Settings › KPIs (HR Module Navigation Map; Phase 8): tabs KPI List (the Personality Trait and Skills
 * KPIs; Soon until its schema is agreed) and Weights (the former KPI Configuration). Opens on Weights;
 * the tab is in the URL (`?tab=`).
 */
export const KpiConfigurationPage = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useUrlTab<KpisTab>([KPIS_TABS.LIST, KPIS_TABS.WEIGHTS], KPIS_TABS.WEIGHTS);

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader title={t('KPIS')} />
      <Tabs value={tab} onValueChange={(value) => setTab(value as KpisTab)}>
        <TabsList className="max-sm:w-full">
          <TabsTrigger value={KPIS_TABS.LIST} className="gap-1.5 max-sm:flex-1">
            {t('KPI_LIST')}
            <SoonBadge />
          </TabsTrigger>
          <TabsTrigger value={KPIS_TABS.WEIGHTS} className="max-sm:flex-1">
            {t('WEIGHTS')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value={KPIS_TABS.LIST} className="mt-4">
          <SoonPanel name="KPI_LIST" />
        </TabsContent>
        <TabsContent value={KPIS_TABS.WEIGHTS} className="mt-4">
          <KpiConfigurationForm />
        </TabsContent>
      </Tabs>
    </div>
  );
};
